// extracted by mini-css-extract-plugin
export var contentBody = "_du-9";
export var headerImage = "_du-2";
export var imageButton = "_du-7";
export var imageButtonIcon = "_du-8";
export var imageHeader = "_du-4";
export var imageHeaderText = "_du-5";
export var imageOverlay = "_du-3";
export var imageTitle = "_du-6";
export var imageWrapper = "_du-1";
export var taskList = "_du-a";
export var widget = "_du-0";